import React from "react";
import { Monitor, Smartphone } from "lucide-react";

export default function PreviewToggle({ mode, onChange }) {
  return (
    <div className="flex bg-white/15 rounded-lg p-0.5">
      <button
        onClick={() => onChange("desktop")}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
          mode === "desktop"
            ? "bg-white text-bookish-purple shadow-sm"
            : "text-white/80 hover:text-white"
        }`}
      >
        <Monitor size={14} />
        Desktop
      </button>
      <button
        onClick={() => onChange("mobile")}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
          mode === "mobile"
            ? "bg-white text-bookish-purple shadow-sm"
            : "text-white/80 hover:text-white"
        }`}
      >
        <Smartphone size={14} />
        Mobile
      </button>
    </div>
  );
}
